import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoWalletConnectionLogListRequest,
  PerplayLogApi,
} from '../../models/src';
import { WALLET_CONNECTION_LIST_REQUEST } from '../../constants/log/walletConnectionLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoWalletConnectionLogListResponse
  from '../../models/src/model/LogControllerDtoWalletConnectionLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* walletConnectionLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoWalletConnectionLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.accountNo = payload.accountNo;
    requestData.walletAddress = payload.walletAddress;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogWalletConnectionLogListPost({ logControllerDtoWalletConnectionLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoWalletConnectionLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* wallectConnectionLogRootSaga() {
  yield all([
    takeEvery(WALLET_CONNECTION_LIST_REQUEST, walletConnectionLogListRequestSaga),
  ]);
}

const walletConnectionLogSaga = [
  fork(wallectConnectionLogRootSaga)
];

export default walletConnectionLogSaga;
